var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",on:{"click":_vm.handleRotate}},[_c('div',{ref:"cover",staticClass:"cover"},[_vm._v("ASG")]),_c('div',{ref:"back",staticClass:"back"},[_vm._v(_vm._s(_vm.back))])])
}
var staticRenderFns = []

export { render, staticRenderFns }